import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';

const MemberDeleted = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [Member, setMember] = useState([]);
  const [selectedMember, setSelectedMember] = useState([]);
  const tableRef = useRef(null);

  const fetchMember = async () => {
    try {
      const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
      const response = await fetch(`${baseurl}/admin/deletedmember`, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`, // Ensure token is sent
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const formattedData = data.map(member => ({
        ...member,
      }));
      setMember(formattedData);
    } catch (error) {
      console.error('Error fetching member:', error);
    }
  };

  useEffect(() => {
    fetchMember();
  }, []);

  useEffect(() => {
    const tableElement = tableRef.current;
  
    if (tableElement) {
      if ($.fn.DataTable.isDataTable(tableElement)) {
        $(tableElement).DataTable().destroy();
      }
  
      const dataTable = $(tableElement).DataTable({
        dom: 'Blfrtip',
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
        buttons: [
          { extend: 'copyHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'csvHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'pdfHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'print', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        ],
        data: Member,
        columns: [
          {
            data: null,
            title: '<input type="checkbox" id="select-all" />',
            orderable: false,
            render: (data, type, row) => `<input type="checkbox" class="row-select" data-id="${row.member_id}" />`,
          },
          { data: null, title: "Sr.No", className: "text-center" },
          {
            data: 'membership_no',
            title: 'Membership No',
            render: (data, type, row) =>
              type !== 'display'
                ? (data ?? '')
                : `<a href="/admin/EditMember?memberId=${row.member_id}&edit=false" onclick="event.preventDefault(); window.open(this.href, '_blank');">${data ?? ''}</a>`,
          },
          { data: 'chapter_id', title: 'Chapter ID' },
          { data: null, title: 'Name' },
          { data: 'mobile_no', title: 'Mobile No' },
          { data: 'email', title: 'Email' },
          { data: 'chapter_name', title: 'Chapter' },
          { data: null, title: 'Action', orderable: false },
        ],
        columnDefs: [
          {
            targets: 1,
            render: (data, type, row, meta) => meta.row + 1,
          },
          {
            targets: 2,
            render: (data) => `<center>${data}</center>`,
          },
          {
            targets: 3,
            render: (data) => `<center>${data}</center>`,
          },
          {
            targets:   4,     
            render: (data, type, row, meta) => `${row.first_name || ''} ${row.last_name || ''}`
          },
          {
            targets: 8,
            render: (data, type, row) => {
              const restoreIcon = `<a href="#" class="restore-icon btn btn-warning btn-sm me-2" data-id="${row.member_id}"><i class="fas fa-trash-arrow-up"></i>&nbsp; Restore</a>`;
              const deleteIcon = roleid === 1 ? `<a href="#" class="delete-icon btn btn-danger btn-sm" style="color:white" data-id="${row.member_id}"><i class="fas fa-trash"></i> Delete Forever</a>` : '';
              return `${restoreIcon} ${deleteIcon}`;
            },
          },
        ],
      });
  
      // Select all checkboxes
$(document).on("click", "#select-all", function () {
  const checked = this.checked;

  // Get only visible Member IDs
  const visibleMemberIds = $(".row-select")
    .map(function () {
      return $(this).data("id");
    })
    .get(); // Convert jQuery object to array

  // Set selected Member based on whether "Select All" is checked
  setSelectedMember(checked ? [...new Set(visibleMemberIds)] : []);
  
  $(".row-select").each(function () {
    $(this).prop("checked", checked).trigger("change");
  });
});

$(document).on('change', '.row-select', function () {
  const MemberId = $(this).data('id');
  if (this.checked) {
    // Add the Member ID only if it's not already in the selectedMember
    setSelectedMember((prev) => [...new Set([...prev, MemberId])]);
  } else {
    // Remove the Member ID from selectedMember
    setSelectedMember((prev) => prev.filter((id) => id !== MemberId));
  }
});
  
      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        if (selectedMember.length === 0) {
          Swal.fire('No Member Selected', 'Please select Member to delete.', 'warning');
          console.log('No Member selected', selectedMember); // Add a log for debugging
          return;
        }
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete the selected Member?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await Promise.all(
              selectedMember.map(MemberId =>
                $.ajax({
                  url: `${baseurl}/admin/member/${MemberId}?permanentdelete=true`,
                  type: 'DELETE',
                  headers: {
                    Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
                  },
                })
              )
            );
            Swal.fire('Deleted!', 'Selected Member deleted successfully.', 'success');
            fetchMember(); // Re-fetch the Member after deletion
            setSelectedMember([]); // Clear selected Member
          } catch (error) {
            console.error('Error deleting selected Member:', error);
            Swal.fire('Error', 'Error deleting selected Member.', 'error');
          }
        }
      });


      $(document).on('click', '.restore-icon', async function (e) {
        e.preventDefault();
        const MemberId = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to Restore this Member?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Restore!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/restoremember/${MemberId}`,
              type: 'PUT',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Restored!', 'Member Restore successfully.', 'success');
            // Re-fetch the Member after deletion
            fetchMember();
          } catch (error) {
            console.error('Error Restore Member:', error);
            Swal.fire('Error', 'Error Restore Member.', 'error');
          }
        }
      });

      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        const MemberId = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete this Member?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/member/${MemberId}?permanentdelete=true`,
              type: 'DELETE',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Deleted!', 'Member permanently deleted successfully.', 'success');
            // Re-fetch the Member after deletion
            fetchMember();
          } catch (error) {
            console.error('Error deleting Member:', error);
            Swal.fire('Error', 'Error deleting Member.', 'error');
          }
        }
      });

      return () => {
        if ($.fn.DataTable.isDataTable(tableElement)) {
          $(tableElement).DataTable().destroy();
        }
      };
    }
  }, [Member]);
  
  // Function to delete selected Admin
  const handleDeleteSelected = async () => {
    console.log("Selected Member before deletion:", selectedMember);
  
    if (selectedMember.length === 0) {
      Swal.fire("No Member Selected", "Please select Member to delete.", "warning");
      return;
    }
  
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanently delete the selected Member?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {
        const token = sessionStorage.getItem("token");
  
        await Promise.all(
          selectedMember.map((MemberId) =>
            $.ajax({
              url: `${baseurl}/admin/member/${MemberId}?permanentdelete=true`,
              type: "DELETE",
              headers: {
                Authorization: `${token}`,
              },
            }).fail((jqXHR, textStatus, errorThrown) => {
              console.error(`Failed to delete Member ID ${MemberId}:`, textStatus, errorThrown);
            })
          )
        );
  
        Swal.fire("Deleted!", "Selected Member deleted successfully.", "success");
  
        fetchMember();
        setSelectedMember([]); // **Reset selectedMember after deletion**
      } catch (error) {
        console.error("Error deleting selected Member:", error);
        Swal.fire("Error", "Error deleting selected Member.", "error");
      }
    }
  };
  

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  
  return (
    <div className="content container-fluid">
      <center><h1>Member Deleted Entries</h1></center>
      <div className="container mt-4">
        <div className="profile-section">
          <button onClick={handleDeleteSelected} className="btn btn-danger mb-3">Delete Selected List</button>
          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <div className="col-12">
                <table ref={tableRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default MemberDeleted;
